<template>
  <div class="borrow">
    <div
      class="box box-primary"
      style="overflow-x: hidden"
    >
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('menu.draft') }}
        </h3>
        <div class="pull-right box-tools d-sm-none d-md-block">
          <template v-if="can([Permissions.backend.draft.filterColumnTable])">
            <router-link
              :to="{name: 'switch-table-column-draft'}"
              class="btn btn-default btn-sm margin-right-5"
            >
              <i class="fa fa-columns" /> {{ $t('label.showOrHideColumns') }}
            </router-link>
          </template>
          <template v-if="can([Permissions.backend.draft.export])">
            <a
              :href="`${baseUrl}/export/applicant/draft`"
              class="btn btn-info btn-sm"
            >
              <i class="fa fa-file-excel-o" /> {{ $t('label.exportAsExcel') }}
            </a>
          </template>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="dataTables_row_up">
            <div class="col-xs-8 col-sm-6 margin-bottom">
              <div class="d-flex">
                <div class="btn-group mr-2">
                  <button
                    type="button"
                    class="btn btn-default"
                  >
                    {{ $t('label.showOrHideColumns') }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="caret" />
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="showColumnRow"
                  >
                    <template v-for="(column, columnIndex) in columns">
                      <li
                        @click="toggleColumn(columnIndex)"
                        :key="columnIndex"
                      >
                        <a
                          href="javascript:void(0)"
                          :class="`${(!oTable || oTable.columns().visible()[columnIndex]) ? 'text-blue' : 'text-red'}`"
                        >
                          <i
                            :class="`fa fa-${(!oTable || oTable.columns().visible()[columnIndex]) ? 'eye' : 'eye-slash'}`"
                          />
                          {{ $t(column.titleKey) }}
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="margin-right-5">
                  <date-picker
                    v-model="dateRange"
                    :placeholder="$t('placeholder.chooseDateRage')"
                    format="DD/MM/YYYY"
                    range
                    :disabled-date="notBeforeToday"
                    :lang="datePickerLocale[$i18n.locale]['lang']"
                  />
                </div>
              </div>
            </div>
            <div class="col-xs-4 col-sm-6 margin-bottom d-md-none d-sm-block">
              <div class="pull-right box-tools">
                <a
                  :href="`${baseUrl}/export/pending`"
                  class="btn btn-info btn-sm"
                >
                  <i class="fa fa-file-excel-o" /> {{ $t('label.exportAsExcel') }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div>
              <table
                id="borrow-table"
                class="table table-hover table-striped table-bordered"
                width="100%"
              >
                <tbody />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comment-modal
      :route-view-all-comments="{
        name: 'show-draft',
        params: {
          borrow_id
        }
      }"
    />
    <assign-loan-officer-modal @refreshList="oTable.draw()" />
    <applicant-cancel-modal @refreshList="oTable.draw()" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CommentModal from '@/views/comments/components/CommentModal'
import AssignLoanOfficerModal from '@/views/borrows/_components/AssignLoanOfficerModal'
import ApplicantCancelModal from '@/views/borrows/_components/ApplicantCancelModal'
import { datePickerLocale } from '@/plugins/datePickerLocale'
import Permissions from '@/permissions'

export default {
  name: 'List',
  components: { ApplicantCancelModal, AssignLoanOfficerModal, CommentModal },
  metaInfo () {
    return {
      title: this.$t('menu.draft'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_API,
      oTable: null,
      dateRange: null,
      filterColumns: [],
      Permissions,
      datePickerLocale
    }
  },
  computed: {
    ...mapState({
      borrow_id: state => state.comment.borrow_id
    }),
    startDate () {
      if (this.dateRange && this.dateRange[0]) {
        return this.$moment(this.dateRange[0]).locale('en').format('YYYY-MM-DD')
      }
      return null
    },
    endDate () {
      if (this.dateRange && this.dateRange[1]) {
        return this.$moment(this.dateRange[1]).locale('en').format('YYYY-MM-DD')
      }
      return null
    },
    columns () {
      if (this.filterColumns && Array.isArray(this.filterColumns) && this.filterColumns.length) {
        return this.filterColumns.map((filterColumn) => {
          const column = JSON.parse(filterColumn.option)
          this.$set(column, 'title', this.$t(column.titleKey))
          return column
        })
      }
      return []
    }
  },
  watch: {
    '$i18n.locale' () {
      this.oTable.destroy()
      this.oTable = this.dataTable()
      this.oTable.draw(true)
    },
    dateRange () {
      this.oTable.draw()
    }
  },
  methods: {
    notBeforeToday (date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0))
    },
    toggleColumn (column) {
      column = this.oTable.column(column)
      column.visible(!column.visible())
    },
    onClickDeleteRecord (recordId) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/delete', { id: recordId })
            .then((response) => {
              if (response.data.code === 1) {
                this.oTable.draw(true)
                this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
              } else {
                this.$toastr('error', response.data.message, this.$t('string.error'))
              }
            })
            .catch((error) => {
              this.onResponseError(error)
            })
        }
      })
    },
    revertToApplicant (recordId) {
      const self = this
      this.$swal({
        title: self.$t('string.moveAsApplication'),
        text: self.$t('string.youWantToMoveTheClient?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesIWantIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/move-from-draft-to-applicant', { id: recordId })
            .then((response) => {
              if (response.data.code === 1) {
                this.oTable.draw(true)
                this.$swal({
                  title: self.$t('string.moved'),
                  text: self.$t('string.theRequestHaveBeenProceeded'),
                  type: 'success',
                  confirmButtonText: self.$t('button.ok')
                })
              }
              if (response.data.code === 0) {
                if (response.data.code === 0) {
                  this.$toastr('error', response.data.message, self.$t('string.moveApplicant'))
                }
              }
            })
            .catch((error) => {
              this.onResponseError(error)
            })
        }
      })
    },
    dataTable () {
      const self = this
      return $('#borrow-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v4/backend/draft/datatable',
          data: (d) => {
            d.status = 'Draft'
            d.labelDelete = self.$t('label.delete')
            d.labelEdit = self.$t('label.edit')
            d.labelToBeApplicant = self.$t('label.toBeApplicant')
            d.noPermission = self.$t('string.noPermission')
            d.commentLabel = self.$t('string.comment')
            d.assignLoanOfficerLabel = self.$t('string.assignLoanOfficer')
            d.na = self.$t('string.na')
            d.startDate = self.startDate
            d.endDate = self.endDate
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: self.columns,
        order: [
          [1, 'desc']
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    ...mapActions('applicantCancel', {
      set_applicable_id_product: 'set_applicable_id_product'
    }),
    enabledAction () {
      this.clearEventHandlers([
        '.borrow-delete',
        '.borrow-to-be-applicant',
        '.borrow-edit',
        '.btn-assign-loan-officer',
        '.borrow-cancel',
        '.btn-comment',
        '.borrow-cancel'
      ])

      const self = this
      $(document).on('click', '.borrow-delete', function (e) {
        e.preventDefault()
        self.onClickDeleteRecord($(this).attr('data-borrow'))
      })
      $(document).on('click', '.borrow-show', function (e) {
        e.preventDefault()
        self.$router.push({
          name: 'BorrowerShow',
          params: {
            id: $(this).attr('data-borrow')
          }
        })
      })
      $(document).on('click', '.borrow-to-be-applicant', function (e) {
        e.preventDefault()
        self.revertToApplicant($(this).attr('data-borrow'))
      })
      $(document).on('click', '.borrow-edit', function (e) {
        e.preventDefault()
        self.$router.push({
          name: 'edit-draft',
          params: {
            borrow_id: $(this).attr('data-borrow')
          }
        })
      })

      // comment
      $(document).on('click', '.btn-comment', function (e) {
        e.preventDefault()
        self.$store.commit('comment/openCommentModal')
        self.$store.commit('comment/setBorrowId', $(this).attr('data-borrow'))
      })
      // assign loan officer
      $(document).on('click', '.btn-assign-loan-officer', function (e) {
        e.preventDefault()
        self.$store.commit('loanOfficerAssignment/toggleAssignLoanOfficerModal')
        self.$store.commit('loanOfficerAssignment/setBorrowId', $(this).attr('data-borrow'))
      })
      // cancel
      $(document).on('click', '.borrow-cancel', function (e) {
        e.preventDefault()
        self.set_applicable_id_product({
          applicantSelected: $(this).attr('data-borrow'),
          product: $(this).attr('data-product-type')
        })
      })
    },
    async getColumns () {
      if (localStorage.hasOwnProperty('draft_columns')) {
        this.filterColumns = JSON.parse(localStorage.getItem('draft_columns'))
        return 0
      }
      await this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/filter-table-column/get-option', {
        model_type: 'Draft'
      }).then(({ data }) => {
        if (data.data) {
          this.filterColumns = data.data
          localStorage.setItem('draft_columns', JSON.stringify(this.filterColumns))
        }
      })
    }
  },
  async mounted () {
    await this.getColumns().then(() => {
      this.oTable = this.dataTable()
      this.enabledAction()
    })

    $(document).ready(function () {
      $('.block').scroll(function () {
        const scrollAmt = $(this).scrollLeft()
        $('.fixedHeader-floating').css('left', 0 - parseInt(scrollAmt) + 'px')
      })
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
